<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/en15-1.jpg"
              width="100%"
              alt="Blueshark R1 10” HD screen"
            />
          </div>
          <div class="text t15">Bluetooth Setting</div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/en15-2.jpg"
              width="100%"
              alt="Blueshark R1 10” HD screen"
            />
          </div>
          <div class="text t15">Music Player</div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/en15-3.jpg"
              width="100%"
              alt="Blueshark R1 10” HD screen"
            />
          </div>
          <div class="text t15">Functional Status</div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination {
  bottom: 5vw !important;
}
.t15 {
  bottom: 8vw;
  text-align: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper_en/swiper15.vue